import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup } from '@angular/forms';

import { Form } from '../../shared/form';
import { HttpErrorHandler } from '../../shared/http-error-handler';

import { InfoCommercializationAssociationService } from '../../_services/commercialization.service';
import { InfoCommercializationAssociation } from 'app/_models/commercialization';

@Component({
  selector: 'app-info-commercialization-association-form',
  templateUrl: './info-commercialization-association-form.component.html',
})
export class InfoCommercializationAssociationFormComponent extends Form implements OnInit {
  infoCommercialization: InfoCommercializationAssociation;
  originalInfoCommercialization: InfoCommercializationAssociation;
  displayConfirmationDialog = false;
  submittedForm: any;

  constructor(
    private infoCommercializationAssociationService: InfoCommercializationAssociationService,
    protected route: ActivatedRoute,
    protected router: Router,
    private location: Location,
    protected httpErrorHandler: HttpErrorHandler
  ) {
    super(route, httpErrorHandler);
    this.infoCommercialization = new InfoCommercializationAssociation();
  }

  ngOnInit() {
    this.getInfoCommercializationAssociation();
  }

  handleError(error) {
    const errors = this.httpErrorHandler.handleHttpError(error);

    console.log(errors);
  }

  onSubmit(form) {
    if (form.invalid || !this.hasChanges()) {
      return;
    }

    this.submittedForm = form;
    this.displayConfirmationDialog = true;
  }

  confirmUpdate() {
    this.displayConfirmationDialog = false;
    this.updateInfoCommercializationAssociation();
  }

  cancelUpdate() {
    this.displayConfirmationDialog = false;

    this.infoCommercialization = Object.assign(new InfoCommercializationAssociation(), this.originalInfoCommercialization);
    if (this.submittedForm) {
      this.submittedForm.form.markAsPristine();
      this.submittedForm.form.markAsUntouched();
    }

    this.submittedForm = null;
  }

  updateInfoCommercializationAssociation() {
    this.infoCommercializationAssociationService.update(this.infoCommercialization).subscribe(
      (infoCommercializationAssociation) => this.onUpdate(infoCommercializationAssociation),
      (error) => this.handleError(error)
    );
  }

  onUpdate(infoCommercializationAssociation) {
    this.infoCommercialization = infoCommercializationAssociation;

    this.originalInfoCommercialization = {
      ...infoCommercializationAssociation,
    };

    if (this.submittedForm) {
      this.submittedForm.form.markAsPristine();
      this.submittedForm.form.markAsUntouched();
    }

    this.submittedForm = null;
  }

  hasChanges(): boolean {
    if (!this.originalInfoCommercialization) {
      return false;
    }

    return (
      this.infoCommercialization.price_minimun !== this.originalInfoCommercialization.price_minimun ||
      this.infoCommercialization.sale_time_limit !== this.originalInfoCommercialization.sale_time_limit
    );
  }

  getInfoCommercializationAssociation() {
    this.infoCommercializationAssociationService.get().subscribe(
      (infoCommercializationAssociation) => {
        this.infoCommercialization = infoCommercializationAssociation;

        this.originalInfoCommercialization = Object.assign(new InfoCommercializationAssociation(), infoCommercializationAssociation);
      },
      (error) => this.handleError(error)
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/sale-offers/info-commercialization-association-form/info-commercialization-association-form.component.ts